export const COLUMNS = [
  {
    Header: "Passport No",
    Footer: "",
    accessor: row => {
      if (row.Employee?.Passports && row.Employee.Passports.length > 0) {
        return row.Employee.Passports[0].passportNo;
      }
      return 'N/A';
    },
  },
  {
    Header: "Full Name",
    Footer: "firstName",
    accessor: row => row.Employee ? `${row.Employee.firstName} ${row.Employee.lastName}` : 'N/A',
  },
  {
    Header: "Mobile",
    Footer: "",
    accessor: row => row.Employee?.mobile || 'N/A',
  },
  {
    Header: "Visa Status",
    Footer: "",
    accessor: row => row.status || 'N/A'
  },
  {
    Header: "Agent",
    Footer: "",
    accessor: row => row.Employee?.Agent?.name || 'N/A',
  },
  {
    Header: "Expiry Date",
    Footer: "",
    accessor: row => row.expiryDate || 'N/A'
  },
  {
    Header: "Days until expiry",
    Footer: "passport",
    accessor: row => row.daysUntilExpiry || 'N/A',
  },
];

